import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../lib/api";
import { PageHeader, DataTable, Pill } from "../components/Table";

const ST = { active: "#34C759", expiring: "#FF9500", expired: "#FF3B30" };

export default function Renewals() {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/renewals").then((r) => setRows(r.data.renewals));
  useEffect(() => { load(); }, []);

  const renew = async (id) => { await api.post(`/renewals/${id}/renew`); toast.success("Renewed for 365 days"); load(); };

  const columns = [
    { key: "vehicle_number", header: "Vehicle", render: (r) => <span className="font-semibold">{r.vehicle_number}</span> },
    { key: "imei", header: "IMEI", render: (r) => <span className="font-mono text-xs">{r.imei}</span> },
    { key: "plan", header: "Plan" },
    { key: "amount", header: "Amount", render: (r) => `₹${r.amount}` },
    { key: "days_left", header: "Days Left", render: (r) => <span style={{ color: ST[r.status] }}>{r.days_left}</span> },
    { key: "status", header: "Status", render: (r) => <Pill color={ST[r.status]}>{r.status}</Pill> },
    { key: "renew", header: "", render: (r) => r.status !== "active"
      ? <button data-testid={`renew-${r.id}`} onClick={() => renew(r.id)} className="text-xs font-semibold px-2 py-1 bg-primary text-white rounded-sm">Renew</button>
      : null },
  ];

  return (
    <div className="p-5 space-y-4">
      <PageHeader title="Renewals & AMC" subtitle="Subscription lifecycle management" />
      <DataTable testid="renewals-table" columns={columns} rows={rows} />
    </div>
  );
}
